// src/Components/SideBarNav/index.tsx
import React, { useState } from 'react';
import GenericSidebar from './GenericSidebar';
import ClientMenu from './clientMenu';
import { useAuth } from 'utils/AuthProvider';

export default function SideBarNav() {
  const { isClient } = useAuth();

  /* 🔄 always call hooks first */
  const [isTaxExpanded, setIsTaxExpanded] = useState(false);
  const [isFinCenExpanded, setIsFinCenExpanded] = useState(false);
  const [isAccountingExpanded, setIsAccountingExpanded] = useState(false);
  const handleToggle =
    (setter: React.Dispatch<React.SetStateAction<boolean>>) =>
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      setter((prev) => !prev);
    };

  /* 🟢 client sees the original menu */
  if (isClient) {
    return (
      <div className="custom-sidebar">
        <div className="custom-menu-items">
          <h2 className="custom-menu-heading">Main Menu</h2>
          <div className="separator" />

          <ClientMenu
            isTaxExpanded={isTaxExpanded}
            setIsTaxExpanded={setIsTaxExpanded}
            isFinCenExpanded={isFinCenExpanded}
            setIsFinCenExpanded={setIsFinCenExpanded}
            isAccountingExpanded={isAccountingExpanded}
            setIsAccountingExpanded={setIsAccountingExpanded}
            handleToggle={handleToggle}
          />
        </div>
      </div>
    );
  }

  /* 🟣 employees (Admin / Accountant) */
  return <GenericSidebar />;
}
